import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  Servicesection2, 
  roleWriting,
} from "../../Data/All_Services_Data/ppcData";
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const PPCMarketing = () => {
    useMetaTags({
      title:
        "Trusted Pay per Click Marketing Services | Warrgyizmorsvh Experts",
      description:
        "Warrgyizmorsvh offers reliable Pay per Click marketing services tailored to your business. Get more leads, targeted traffic, and measurable results with PPC experts.",
      keywords:
        "Pay Per Click Marketing Services, ppc marketing, Pay per Click Marketing, pay per click advertising, pay per click campaign, PPC Advertising, ppc agency, ppc company, pay per click ads, ppc advertising company, ppc advertising agencies, ppc pay per click advertising, pay per click marketing, ppc marketing services",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Your Trusted Pay per Click Marketing Services: Warrgyizmorsch
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        .services-container{
            padding: 20px 0px !important;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/ppcImage.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    At Warrgyizmorsch we are dedicated to bringing you top
                    performance PPC marketing services which see great results
                    for your business. Our team of experts which is at the top
                    of their field work with you to put together custom
                    campaigns that zero in on your best audience, which in turn
                    gets pay per click marketing services to put your ads out at
                    the perfect time. We put in the strategy, the precision, and
                    we maximize ROI which in turn we see every click through to
                    a valuable interaction for your brand.
                  </p>
                </div>
              </div>
              <Services_we_offer data={ServicesSection} />

              <Services_we_offer data={Servicesection2} />
              {/* Professional PPC Marketing Services */}
              <Handle_Largedata_section LargeData={LargeData} />
              {/* What Are the Main Types of PPC Ads? */}
              <Custom_section data={CustomSection} />
              {/* Our Clients Appreciate Our Collaborative Approach  */}
              <Role_writing data={roleWriting} />
              {/* Are You Looking for Experienced Pay per Click Marketing?  */}
              <Boost_section data={BoostSection} />
              {/* Why Warrgyizmorsch Is the Best Choice for Pay per Click Marketing?  */}
              <Assistance_section data={AssistanceSection} />
              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default PPCMarketing;